import Model from 'src/storage/base';
import { openApp } from '../../helpers';

class AuthModel extends Model {
  id = 'auth';
  persistent = false;

  defaultState = () => ({
    signupUrl: '/signup'
  });

  apiConfig = {
    password: {
      url: 'auth/password',
      validation: {
        username: 'emailAddress',
        password: 'password'
      },
      cancellable: true
    }
  };

  _events = {
    location: 'initLocation'
  };

  initLocation = (data) => {
    this.setState({ countryAddress: data.country });
  };

  loginPassword = (cb) => {
    let req = {
      username: this.state.username,
      password: this.state.password
    };
    this.api('password', req, (err, data, success) => {
      cb && cb(err, data, success);
      !err && openApp();
      this.onLogin(err, data, success);
    });
  };

  onLogin = (error, data, success) => {
    if (success) {
      this.emit('auth', data);
    }
  };
}

const model = new AuthModel();
export default model;
